import { render, staticRenderFns } from "./BrandResultPage.vue?vue&type=template&id=08f1f080"
import script from "./BrandResultPage.vue?vue&type=script&lang=js"
export * from "./BrandResultPage.vue?vue&type=script&lang=js"
import style0 from "./BrandResultPage.vue?vue&type=style&index=0&id=08f1f080&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports